import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { HttpErrorResponse } from '@angular/common/http';

import { Subscription, filter, startWith } from 'rxjs';
 
import { ProjectsService, ProjectsEditorService } from '@app/services/app/projects.service';
import { AppService } from '@app/services/app/app.service';

import { TitleService } from '@core/services/title.service';
import { MenuItem } from '@core/models/menu-item.model';

import { Request,BasicRequest } from '@core/objects/request';

import { projectDetailsMenu } from '@app/models/menu/projects.menu';

@Component({
    selector: 'project-details-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProjectDetailsMainComponent implements OnInit, OnDestroy {
    private readonly FORMS_FEATURE_PLUGIN = "custom-forms";

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ACCESS_DONE = 2;
    public readonly STATUS_NOT_ACCESS_VERSION_DONE = 3;
    public readonly STATUS_NOT_FOUND = 4;
    public readonly STATUS_ERROR = 5;

    public status: number = 0;
    public menuProjects: Array<MenuItem> = projectDetailsMenu;

    public accessReadMessages: boolean = false;
    public accessWriteMessages: boolean = false;

    public project: Request;
    public projectHeader: BasicRequest = null;
    protected projectId: number;
    protected versionId: number;

    protected isTabKey: boolean = false;
    protected isPKey: boolean = false;

    private _accessForms: boolean | null = null;
    private subs = new Subscription();

	constructor(
        private projectsSrv: ProjectsService, 
        private editorSrv: ProjectsEditorService,
        private title: TitleService, 
        public appSrv: AppService,
        private activeRoute: ActivatedRoute,
        private router: Router
        ){}

    // public getters 
    get accessForms(): boolean {
        return this._accessForms || false; // Return false if _accessFeedbacks is null
    }

    ngOnInit(){
        this.title.set("Project #");
        this.subs.add(
            this.router.events.pipe(
                filter(e => e instanceof NavigationEnd),
                startWith(null) // for first time load
            ).subscribe(() => {
                const allParams = this.collectParams(this.activeRoute.snapshot.root);
                let pid: number = +allParams.id;

                if (pid != this.projectId) {
                    this.projectId = pid;
                    this.projectsSrv.load(pid);
                }

                // when we have version on the route for child routes we need to know to enable routing.
                if (allParams.vid) { 
                    this.versionId = +allParams.vid;
                } else {
                    this.versionId = null;
                }

                this.init();
            })
        );


        this.subs.add( this.projectsSrv.selectProject().subscribe((project: Request) => {
            if(project == null) return;
            this.setProject(project);
        }));

        this.subs.add( this.projectsSrv.selectProjectHeader().subscribe((header: Request) => {
            if(header == null) return;
            this.projectHeader = header;
            this.updateMenu(this.projectHeader);
            this.init()
        }));

        // get forms access
        this.subs.add( 
            this.appSrv.getSession().subscribe(session => {
                this._accessForms = session?.options?.plugins?.some((pa) => pa == this.FORMS_FEATURE_PLUGIN);
                this.updateMenu(this.project);
            })
        );


        this.subs.add( this.projectsSrv.selectError('load_project').subscribe((error: HttpErrorResponse) => this.setError(error)));

	}

    private collectParams(route: any, params: any = {}): any {
        if (route.params) params = { ...params, ...route.params };
        if (route.firstChild) return this.collectParams(route.firstChild, params);
        return params;
    }

    ngOnDestroy() {
        this.projectsSrv.clear();
        this.editorSrv.clearTransitions();
        this.editorSrv.clearAccess();
        // short way to unsubscribe all subs
        this.subs.unsubscribe();
    }

    private init() {
        this.status = this.STATUS_LOADING;
        // CASE 1: project loaded (Access granted)
        if (this.project != null) {
            this.status = this.STATUS_DONE;
            return; // no further checks needed
        }

        // CASE 2: We have partial information (Restricted access)
        if (this.projectHeader != null) {
            this.status = this.versionId != null ? this.STATUS_NOT_ACCESS_VERSION_DONE : this.STATUS_NOT_ACCESS_DONE;
        }
    }


    protected setError(error: HttpErrorResponse) {

        // console.log("errrroooooorrrr--->", error);
        if(error == null)
            return;

        switch(error.status) {
            case 500:
                this.status = this.STATUS_ERROR;
                break;
            case 404:
                this.status = this.STATUS_NOT_FOUND;
                break;
            // case 403:
            //     this.status = this.STATUS_NOT_ALLOWED;
            //     break;
        }
    }

    protected setProject(project: Request) {
        // RESET THE MENU WIHT THE NEW ID. Case when clic on See original project in project artwork screen.
        if( this.project && this.project.id != project.id )
            this.menuProjects = projectDetailsMenu;
        
        this.project = project;
        this.projectHeader = null; // when available project come we clear header
        this.updateMenu(project);
        this.title.set("Project "+this.project.id);
        this.status = this.STATUS_DONE;
    }

    // with this works the selected items in nav according activeRoute.
    protected updateMenu(project: Request | BasicRequest){
        if( project == null)
            return;
        let pdMenu: Array<MenuItem> = [...this.menuProjects];
        if(this.accessForms !== null && !this.accessForms){
            pdMenu = projectDetailsMenu.filter((mp: MenuItem) => mp.title !== 'Forms');
        }
        this.menuProjects = pdMenu.map((item: MenuItem) => {
            return {...item, link: item.link.replace(':id', project.id.toString()) }
        });
    }

}
